<script setup lang="ts">
import { cva, VariantProps } from 'class-variance-authority'
import { computed } from 'vue'

import { CURRENCY, PurchaseOptions } from '@toni/commerce-api-types'
import { BadgeDiscount } from '@toni/brand-ui'

import { mapCurrency } from '../utils/mapCurrency'
import { PurchaseOptionProps } from './PurchaseOption.vue'

const purchasePriceVariants = cva('', {
  variants: {
    variant: {
      primary: 'text-text-secondary',
      highlighted: 'text-text-secondaryInverted'
    }
  }
})

type PurchasePriceProps = VariantProps<typeof purchasePriceVariants>

const props = defineProps<{
  variant: PurchasePriceProps['variant'],
  purchaseOption: PurchaseOptions[0],
  size: PurchaseOptionProps['size'],
  isComparison: boolean
}>()

const price = computed(() => props.purchaseOption.price).value
const formattedPrice = mapCurrency(price?.amount, price?.currency as CURRENCY)
const formattedRrp = mapCurrency(price?.rrp, price?.currency as CURRENCY)
const renderDiscount: boolean = price?.rrp !== price?.amount
</script>

<template>
  <div v-if="price"
       class="flex justify-center lg:items-center items-end flex-col-reverse lg:flex-row min-h-[2.75rem]"
       :class="isComparison ? '!items-start !flex-col-reverse' : ''">
    <div v-if="renderDiscount"
         class="text-sm flex items-center mx-1">
      <BadgeDiscount v-if="price.savingPercent"
                     :discount="price.savingPercent" />
      <span :class="purchasePriceVariants({ variant })"
            class="line-through ml-1 line-clamp-1">{{ formattedRrp }}</span>
    </div>
    <div v-if="price?.amount && price.amount > 0"
         :class="size === 'lg' ? 'lg:mx-6': 'whitespace-nowrap'">
      <span class="line-clamp-1">{{ formattedPrice }}</span>
    </div>
  </div>
</template>
